window.addEventListener("load", function () {
    const milestoneSwiper = new Swiper('.swiper_milestone', {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    
});
